export enum SubscriptionBillingPeriodEnum {
  PAST = 'past',
  NEXT = 'next',
  SUBSEQUENT_PAYMENT = 'subsequent_payment',
  PREPAYMENT = 'prepayment'
}
